<div bsModal #infoPopup="bs-modal" class="modal fade center-modal z-index-1110" id="InfoPopup"
  tabindex="-1" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content box-shadow-popup rounded-18">
      <div class="modal-header d-flex align-items-center justify-content-between px-20 py-14" style="border-bottom:1px solid #e5e7eb; background:#fff;">
        <span class="f-size-15 font-weight-semibold text-gray-900">{{ title }}</span>
        <button type="button" (click)="closeInfoPopup()" aria-label="Close" class="vf-modal-close-btn">
          <lucide-icon name="x" size="16" [strokeWidth]="2"></lucide-icon>
        </button>
      </div>
      <div class="modal-body px-20 py-16" style="min-height:unset !important; overflow-y:visible;">
        <p class="f-size-14 text-gray-700 mb-0" style="line-height:1.5;">{{information}}</p>
      </div>
      <div class="modal-footer d-flex justify-content-end px-20 py-12" style="border-top:1px solid #e5e7eb; background:#fff;">
        <button type="button" (click)="closeInfoPopup()"
          class="btn btn-black rounded-8 f-size-14 font-weight-medium px-16 py-8">Ok
        </button>
      </div>
    </div>
  </div>
</div>
